import React from 'react';

const LoadHome = React.lazy( () => import( './components/routes/home/home.jsx' ) );
const LoadPersonSearch = React.lazy( () => import( './components/routes/person-search' ) );
const LoadPersonFileList = React.lazy( () => import( './components/routes/person-file-list' ) );
const LoadPersonFileDetail = React.lazy( () => import( './components/routes/person-file-details' ) );
const LoadHierarchyFileList = React.lazy( () => import( './components/routes/hierarchy-file-list' ) );
const LoadHierarchyFileDetail = React.lazy( () => import( './components/routes/hierarchy-file-details' ) );
const LoadHierarchies = React.lazy( () => import( './components/routes/hierarchies' ) );
const LoadPersonAttributes = React.lazy( () => import( './components/routes/person-attributes' ) );
const LoadPersonDetail = React.lazy( () => import( './components/routes/person-detail' ) );
const LoadGroups = React.lazy( () => import( './components/routes/groups' ) );

const Bundle = ( Component, routeProps = {} ) => (
    ( props ) => (
        <Component { ...props } { ...routeProps } />
    )
);

export const routes = [ 
    {
        title: 'Roster Studio',
        pattern: '/',
        render: ( props ) => (
            <LoadHome { ...props }/>
        )
    },
    {
        title: 'Roster Studio',
        pattern: '/:companyId/person-search',
        render: ( props ) => (
            <LoadPersonSearch { ...props }/>
        )
    },
    {
        title: 'Person Files',
        pattern: '/:companyId/person-files',
        render: ( props ) => (
            <LoadPersonFileList { ...props }/>
        )
    },
    {
        title: 'Person File Details',
        pattern: '/:companyId/person-files/:fileId',
        render: ( props ) => (
            <LoadPersonFileDetail { ...props }/>
        )
    },
    {
        title: 'Hierarchy Files',
        pattern: '/:companyId/hierarchy-files',
        render: ( props ) => (
            <LoadHierarchyFileList { ...props }/>
        )
    },
    {
        title: 'Hierarchy File Details',
        pattern: '/:companyId/hierarchy-files/:fileId',
        render: ( props ) => (
            <LoadHierarchyFileDetail { ...props }/>
        )
    },
    {
        title: 'Hierarchies',
        pattern: '/:companyId/hierarchies',
        render: ( props ) => (
            <LoadHierarchies { ...props }/>
        )
    },
    {
        title: 'Person Attributes',
        pattern: '/:companyId/person-attributes',
        render: ( props ) => (
            <LoadPersonAttributes { ...props }/>
        )
    },
    {
        title: 'Person Detail',
        pattern: '/:companyId/person-detail/:personId',
        render: ( props ) => (
            <LoadPersonDetail { ...props }/>
        )
    },
    {
        title: 'Groups',
        pattern: '/:companyId/groups',
        render: ( props ) => ( 
            <LoadGroups { ...props }/>
        )
    }
];

export function bundleRoutingMiddleware( action, nextRoute, prevRoute ) {
    const { match } = nextRoute;

    if (
        match &&
        !match.render &&
        typeof match.load === 'function'
    ) {
        match.load( ( asyncModule ) => {
            match.render = Bundle(
                asyncModule.default ?
                    asyncModule.default
                    :
                    asyncModule, match.props
            );
            action.ok();
        } );
    } else {
        action.ok();
    }
}
